import { homeDir } from "@tauri-apps/api/path";
import { homeFromWire } from "../dialogDefaults";
import type { Maybe } from "../maybe";
import { nothing } from "../maybe";

/** The user's home folder via Tauri, or Nothing when unavailable. */
export async function resolveHomeDir(): Promise<Maybe<string>> {
  try {
    return homeFromWire(await homeDir());
  } catch (error) {
    console.warn("Home directory unavailable for dialog default", error);
    return nothing;
  }
}
